var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { createStripesSource } from "../utils/createStripesSource";
import { fetchAgencyPrefixes } from "../api/agencyPrefixesService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var useAgencyPrefixesData = function (filters, pageSize) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(0), totalRecords = _c[0], setTotalRecords = _c[1];
    var _d = useQuery(["agency-prefixes", filters, pageOffset, pageSize], function () {
        return fetchAgencyPrefixes(ky, __assign(__assign({}, filters), { offset: pageOffset, limit: pageSize }));
    }, {
        keepPreviousData: true,
        onSuccess: function (res) { var _a; return setTotalRecords((_a = res.totalRecords) !== null && _a !== void 0 ? _a : 0); },
    }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, refetch = _d.refetch;
    var agencyPrefixesData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    var source = createStripesSource({
        ky: ky,
        data: agencyPrefixesData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        isLoaded: !isLoading,
        fetchMore: function () { return fetchMoreData(pageOffset + pageSize); },
    });
    return {
        agencyPrefixesData: agencyPrefixesData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        source: source,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
